module.exports = __webpack_public_path__ + "img/doutores-da-web.9b336edc.png";